export default {
    'pt-br': {
        menu: {
            sobre: 'Sobre',
            profissionais: 'Profissionais',
            equipe: 'Equipe',
            eventos: 'Eventos',
            lotes: 'Valores',
            fundadores: 'Fundadores',
            hoteis: 'Hotel',
            informacoes: {
                principal: 'Informações',
                hoteis: 'Hotel',
                guia: 'Guia do evento',
                restaurantes: 'Restaurante',
                aulas: 'Aulas',
                grade: 'Grade de aulas',
                baile: 'Bailes',
                dvturismo: 'DV Turismo'
            },
            certificado: 'Certificado 2019',
            contato: 'Contato',
            login: 'Entrar',
            create: 'Cadastrar',
            logout: 'Sair',
            perfil: 'Minha conta'
        },
        contato: {
            titulo: 'Contato',
            input: {
                nome: 'Nome completo',
                email: 'E-mail',
                telefone: 'Whatsapp',
                assunto: 'Assunto',
                mensagem: 'Sua mensagem aqui',
                enviar: 'Enviar'
            },
            info: {
                telefone: 'Whatsapp',
                email: 'E-mail',
                facebook: 'Facebook',
                instagram: 'Instagram',
                twitter: 'Twitter',
                youtube: 'Youtube'
            },
            notification: {
                nome: 'Informe o seu nome por favor.',
                email: 'O seu e-mail é importante!',
                telefone: 'Vamos conversar por telefone? Informe-o por favor.',
                assunto: 'Diga-nos qual é o assunto',
                mensagem: 'Deixe sua mensagem.',
                enviado: 'Sua menagem foi enviada, logo retornaremos! ;)',
                falha: 'Ops! Não foi possível enviar sua mensagem. <br><br> Entre em contato conosco por algum dos nossos canais sociais. ;)',
                eba: 'Eba!',
                obrigatorio: 'Campo obrigatório!'
            }
        },
        videos: {
            titulo: 'Vídeos',
            botao: 'Assistir no YouTube',
            swiper: {
                anterior: '< Anterior',
                proximo: 'Próximo >'
            }
        },
        profissionais: {
            titulo: 'Profissionais',
            botao: 'Ver agenda completa'
        },
        sobre: {
            titulo: 'Sobre o Samba Maníacos',
            texto: '<p>O Samba Maníacos é um evento cujo objetivo principal é promover o samba de gafieira e suas vertentes.</p><p>Nascido em São Paulo, em 2011, e desde 2014 tendo como sede o Rio de Janeiro, o Sambamaníacos foi e é um dos grandes promotores da nossa dança, da nossa cultura brasileira, através de eventos dançantes compostos de aulas, bailes e palestras, tanto em sua cidade-sede quanto em outras cidades do Brasil, tendo, inclusive, realizado uma edição internacional em Lyon e está indo para a sua segunda edição em Galícia na Espanha.</p><p>Em muitas de nossas edições, também temos a participação de artistas populares entre o público da gafieira, tais como João Sabiá, Fernando Ébano, Joey Mattos (do programa The Voice Brasil), Walmir Borges, Dhema, entre outros.</p><p>Para a realização de nossa missão, contamos com uma equipe de produção compromissada e proativa, todos envolvidos profundamente com a dança de salão e o samba de gafieira, buscando sempre unir os amantes de samba, profissionais e estudantes, em nossos eventos. Portanto, buscar a união e a difusão do nosso samba pelo Brasil e pelo mundo.</p><p>O Samba Vai Dominar O Mundo!</p>'
        },
        footer: {
            direitos: 'Todos os direitos reservados',
            copright: '© 2019 Samba Maníacos',
            feitoPor: 'Made with love by',
            nome: 'Felipe Augusto'
        },
        botao: {
            voltar: 'Voltar'
        },
        login: {
            titulo: 'Login',
            botao: {
                entrar: 'Entrar',
                cadastrar: 'Cadastrar',
                recuperar: 'Esqueci minha senha'
            },
            email: {
                label: 'E-mail:',
                placeholder: 'seu@email.com.br'
            },
            senha: {
                label: 'Senha:',
                placeholder: '*********'
            }
        },
        cadastro: {
            titulo: 'Cadastrar',
            botao: {
                finalizar: 'Pronto'
            },
            email: {
                label: 'Melhor E-mail: *',
                placeholder: 'seu@email.com.br',
                erro: 'Informe um e-mail válido!'
            },
            senha: {
                label: 'Senha: *',
                placeholder: '*********',
                descricao: 'Mínimo 6 caracteres',
                erro: 'Informe uma senha válida!'
            },
            nome: {
                label: 'Nome: *',
                placeholder: '',
                erro: 'Informe o seu nome!'
            },
            sobrenome: {
                label: 'Sobrenome: *',
                placeholder: '',
                erro: 'Informe seu sobrenome!'
            },
            telefone: {
                label: 'Telefone: *',
                placeholder: '(__) _ ____.____',
                erro: 'Informe um telefone válido!'
            },
            cpf: {
                label: 'CPF: *',
                placeholder: '___.___.___-__',
                erro: 'Informe um CPF válido!'
            },
            aniversario: {
                label: 'Aniversário: *',
                placeholder: '__/__/____',
                erro: 'Informe uma data válida!'
            },

            cep: {
                label: 'CEP: *',
                placeholder: '_____-___',
                erro: 'Informe um CEP válido!'
            },
            pais: {
                label: 'País: *',
                placeholder: '',
                erro: 'Informe seu país!'
            },
            cidade: {
                label: 'Cidade: *',
                placeholder: '',
                erro: 'Informe sua cidade!'
            },
            estado: {
                label: 'Estado:',
                placeholder: '',
                erro: 'Informe seu estado!'
            },
            bairro: {
                label: 'Bairro:',
                placeholder: '',
                erro: 'Informe seu bairro!'
            },
            rua: {
                label: 'Rua:',
                placeholder: '',
                erro: 'Informe a rua da residência!'
            },
            numero: {
                label: 'Número:',
                placeholder: '',
                erro: 'Informe o número da residência!'
            },
            complemento: {
                label: 'Complemento:',
                placeholder: ''
            }
        },
        evento: {
            apartir: 'a partir das',
            aconfirmar: 'A confirmar',
            valor: 'Valor',
            endereco: 'Endereço',
            banner: {
                titulo: 'Agenda maníaca',
                descricao: 'Programação completa dos eventos 2020'
            }
        },
        bailes: {
            banner: {
                titulo: 'Bailes Samba Maníacos 2020',
                descricao: 'Não fique de fora dos 4 bailes oficiais do SM 2020'
            }
        }
    }
}
